var yaCountInited = localize({
	en: 'yacounter12932281inited',
	ru: 'yacounter12917275inited'
});

var yaCount;

$(document).on(yaCountInited, function () {
	if (getLang() == 'ru') {
		yaCount = yaCounter12917275;
	} else if (getLang() == 'en') {
		yaCount = yaCounter12932281;
	} else {

	}
});

$('.js-goal-left').on('click', function() {
	if(window.ga && ga.loaded) {
		ga('send', 'event', 'banners', 'click', 'left banner');
	}
	if(yaCount) {
		yaCount.reachGoal('main_banner-left');
	}
})

$('.js-goal-center').on('click', function() {
	if(window.ga && ga.loaded) {
		ga('send', 'event', 'banners', 'click', 'center banner');
	}
	if(yaCount) {
		yaCount.reachGoal('main_banner-center');
	}
})

$('.js-goal-right').on('click', function() {
	if(window.ga && ga.loaded) {
		ga('send', 'event', 'banners', 'click', 'right banner');
	}
	if(yaCount) {
		yaCount.reachGoal('main_banner-right');
	}
})



// WEBPACK FOOTER //
// ./frontend/components/counters/counters.js